import { render } from "./NftCard.vue?vue&type=template&id=15e90052&scoped=true"
import script from "./NftCard.vue?vue&type=script&lang=js"
export * from "./NftCard.vue?vue&type=script&lang=js"

import "@/Common/Styles/nftCard.scss?vue&type=style&index=0&id=15e90052&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e90052"]])

export default __exports__